// src/lib/db/storageAdapter.js
// ─────────────────────────────────────────────────────────────────────────────
//  Runtime storage backend switch: IndexedDB on web/PWA, SQLite on native
//  (Capacitor) builds. syncManager.js and useSyncStore.js import from here
//  instead of '@/lib/db/indexedDB' directly, and never need to know which
//  backend is actually active.
//
//  The backend module is resolved once (cached in _backendPromise) via
//  Capacitor.isNativePlatform().
// ─────────────────────────────────────────────────────────────────────────────
import { Capacitor } from '@capacitor/core';

let _backendPromise = null;
function getBackend() {
  if (!_backendPromise) {
    _backendPromise = Capacitor.isNativePlatform()
      ? import('./sqlite.js')
      : import('./indexedDB.js');
  }
  return _backendPromise;
}

export async function idbGet(key) {
  return (await getBackend()).idbGet(key);
}

export async function idbSet(key, value) {
  return (await getBackend()).idbSet(key, value);
}

export async function idbDelete(key) {
  return (await getBackend()).idbDelete(key);
}

export async function idbGetAllKeys() {
  return (await getBackend()).idbGetAllKeys();
}

export async function enqueuePending(key, value, uid = null) {
  return (await getBackend()).enqueuePending(key, value, uid);
}

export async function getPendingQueue() {
  return (await getBackend()).getPendingQueue();
}

export async function removePending(id) {
  return (await getBackend()).removePending(id);
}

export async function clearPendingQueue() {
  return (await getBackend()).clearPendingQueue();
}

export async function clearAppData() {
  return (await getBackend()).clearAppData();
}

export async function getLatestPendingByKey(uid = null) {
  return (await getBackend()).getLatestPendingByKey(uid);
}

export async function getBibleData() {
  return (await getBackend()).getBibleData();
}

export async function setBibleData(data) {
  return (await getBackend()).setBibleData(data);
}

export async function hasBibleData() {
  return (await getBackend()).hasBibleData();
}